












import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class TedsLauncherIcon extends Vue {
  @Prop()
  public name!: string

  @Prop()
  public link!: string

  @Prop()
  public description!: string

  public openLink(): void {
    window.open(this.link, '_blank')
  }
}
